import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkFeedEventImplEncoder } from "../../encoder/BenchmarkFeedEventImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkFeedEvent } from "../BenchmarkFeedEvent";

export class BenchmarkFeedEventImpl extends ConcreteEncodable implements BenchmarkFeedEvent {
  public static enType: string = "com.bcdfx.streaming.impl.BenchmarkFeedEventImpl";

  /*FID=1*/
  public marketDateEvent: CubiqTS.MarketDataEvent | null = null;
  /*FID=2*/
  public benchmarkCode: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkFeedEventImplEncoder.Instance;
    this.setEncodableType(BenchmarkFeedEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkFeedEventImpl[" +
      "marketDateEvent=" +
      this.marketDateEvent +
      "benchmarkCode=" +
      this.benchmarkCode +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
